import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Referral, ReferralData } from 'src/shared/schemas/referrals'

const updateReferral = (referralId: number, referralData: ReferralData) => {
  return putRequest<Referral>(`/referrals/?id=${referralId}`, referralData)
}

export const useUpdateReferral = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ referralId, referralData }: { referralId: number; referralData: ReferralData }) =>
      updateReferral(referralId, referralData),
    onSuccess: (_, { referralId }) => {
      queryClient.invalidateQueries({ queryKey: queries.referrals.list._def })
      queryClient.invalidateQueries({ queryKey: queries.referrals.detail(referralId).queryKey })
    },
  })
}
